import { formatDate } from "@angular/common";
import { FormGroup } from "@angular/forms";
import { environment } from "src/environments/environment";
import { mimeTypes } from "../constants/mime-type";
import { TableColumnType } from "../constants/table";
import { ResourceLink } from "../models/resource-link";
import { TableColumn, MatTableLoad } from "../models/table";
import { ListItem } from "../models/listItem";
import { MaskPatterns } from "../constants/masks";


export class HelperService {

    public extractObjectPorpertyValue(objElement: any, propertyId: string): any {
        const splitProperties: string[] = propertyId.split('.');
        let value: any = objElement;

        splitProperties.forEach((sp: string) => {
            value = value[sp];
        });

        return value;
    }

    public dataURItoBlob(dataURI: string): Blob {
        const binary: string = atob(dataURI.split(',')[1]);
        const array: number[] = [];
        for (let i = 0; i < binary.length; i++) { array.push(binary.charCodeAt(i)); }

        return new Blob([new Uint8Array(array)], { type: mimeTypes["image/png"].toString() });
    }

    public convertDateToMaterialDate(oldDate: any): string {
        return formatDate(oldDate, 'yyyy-MM-dd', 'en_US');
    }

    public convertDateToPayloadString(value: string): string {
        return new Date(value).toISOString().slice(0, 19);
    }

    public toShortDate(oldDate: Date): string {
        var l_Date = new Date(oldDate);
        return (l_Date.getMonth() + 1) + "/" + l_Date.getDate() + "/" + l_Date.getFullYear();
    }

    public getNextMonthStartDate(): string {
        const today = new Date();
        let nextMonth: Date;
        if (today.getMonth() === 11) {
            nextMonth = new Date((today.getFullYear() + 1), 0, 1);
        } else {
            nextMonth = new Date(today.getFullYear(), (today.getMonth() + 1), 1);
        }

        return formatDate(nextMonth, 'MM/dd/yyyy', 'en');
    }

    public camelCase(str: string) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, '');
    }

    public isEmpty(item: any): boolean {
        if (item == undefined)
            return true;

        if (item == null)
            return true;

        if (item == '')
            return true;

        return false;
    }

    public print(): void {
        window.print();
    }

    public printComponent(componentId: string): void {
        let printContent = document.getElementById(componentId).innerHTML;
        const WindowPrt = window.open('', '', 'left=50%,top=50%,width=800,height=800,toolbar=0,scrollbars=0,status=0');
        WindowPrt.document.write(printContent);
        WindowPrt.document.write('<link rel="stylesheet" type="text/css" href="styles.css">');
        WindowPrt.document.close();
        WindowPrt.focus();
        WindowPrt.print();
        WindowPrt.close();
    }
    /**
     * Download type is the blob type, the document name must have file extension type 
     * @param binaryData 
     * @param downloadType 
     * @param documentName 
     */

    public downloadDocument(binaryData: any[], downloadType: string, documentName: string): void {
        let l_DownloadLink = document.createElement('a');
        l_DownloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: downloadType }));
        l_DownloadLink.target = '_self';
        l_DownloadLink.download = documentName;
        l_DownloadLink.click();
        l_DownloadLink.remove();
    }

    // Standards:
    // https://www.ibm.com/docs/en/order-management-sw/9.3.0?topic=solution-handling-credit-cards
    // https://www.creditcardinsider.com/learn/anatomy-of-a-credit-card/
    public determineCardType(cardInput: string): string {
        let l_CardType: string;
        if (cardInput.startsWith('34') || cardInput.startsWith('37'))
            l_CardType = 'AMEX';

        else if (cardInput.startsWith('30') || cardInput.startsWith('36') || cardInput.startsWith('38'))
            l_CardType = 'DinersClub';

        else if (cardInput.startsWith('4'))
            l_CardType = 'Visa';

        else if (cardInput.startsWith('5'))
            l_CardType = 'Mastercard';

        else if (cardInput.startsWith('6'))
            l_CardType = 'Discover';

        else if (cardInput.startsWith('2123') ||
            cardInput.startsWith('1800') ||
            cardInput.startsWith('31') ||
            cardInput.startsWith('32') ||
            cardInput.startsWith('33') ||
            cardInput.startsWith('35') ||
            cardInput.startsWith('39'))
            l_CardType = 'JCB';

        else
            l_CardType = null;

        return l_CardType;
    }

    public generateResourceIcons(resourceList: ResourceLink[]): ResourceLink[] {
        resourceList.forEach((resource: ResourceLink) => {
            resource.fileType = resource.fileType.toLowerCase();
            switch (resource.fileType) {
                case 'pdf':
                    resource.fileType = 'picture_as_pdf';
                    break;
                case 'mp4':
                    resource.fileType = 'video_library';
                    break;
                default:
                    resource.fileType = 'public';
                    break;
            }

            if (resource.fileName && resource.fileName.indexOf(environment.host) === -1) {
                resource.fileName = `${environment.host}${resource.fileName}`;
            }
        });

        return resourceList;
    }

    /**
     * Add property to mwp-table [isCustomColumnNameMatchValueName]="true"
     * 
     * Swap rows into columns and columns into row
     * Example:
     * 
     * From:
     * {
     *  0: {Attribute: 'Plan Features', CompanyPpo: 'COMPANY PPO'}
     *  1: {Attribute: 'Deductible:', CompanyPpo: '$500 Employee Only / $1,000 Family'}
     *  2: {Attribute: 'Maximum Out of Pocket:', CompanyPpo: '$4,000 / $8,000'}
     * }
     * 
     * To:
     * {
     *  0: {
     *      Plan Features: "COMPANY PPO",
     *      Deductible:: "$500 Employee Only / $1,000 Family",
     *      Maximum Out of Pocket:: "$4,000 / $8,000"
     *  }
     * }
     */
    public convertTableRowsToColumns(model: any[], skipIndex0: boolean): MatTableLoad {
        const data = new Array();
        const columns = new Array<TableColumn>();

        const keys = Object.keys(model[0]);

        model.forEach((m, index) => {
            const l_ModelValue = this.getTypeOfValue(m, keys[0]);
            columns.push({
                columnId: index,
                propertyId: l_ModelValue,
                columnName: l_ModelValue,
                columnType: TableColumnType.label,
            });
        });

        keys.forEach((k, keyIndex) => {
            if (skipIndex0 && keyIndex == 0) {
                // Skip
            } else {
                let row = new Array();
                columns.forEach((c: TableColumn) => {
                    const modelRow = model[c.columnId];
                    const dataEntry = this.getTypeOfValue(modelRow, k);
                    row.push({ [c.columnName]: dataEntry });
                });

                // Converts Array To Object
                const newDataRow = row.reduce(function (result, item) {
                    const reduceKey = Object.keys(item)[0];
                    result[reduceKey] = item[reduceKey];
                    return result;
                }, {});

                data.push(newDataRow);
            }
        });

        return {
            tableColumns: columns,
            data: data
        };
    }

    public getTypeOfValue(model: any, value: any): any {
        return model[value as keyof typeof model];
    }

    public getEnumByKey<E extends Record<string, string | number>>(enumObj: E, value: any): any {
        return (Object.keys(enumObj) as Array<keyof E>).find(key => enumObj[key] === value);
    }

    public getEnumKeyByValue<E extends Record<string, string | number>>(enumObj: E, value: any): any {
        return (Object.keys(enumObj) as Array<keyof E>).find(key => enumObj[key as keyof typeof enumObj] === value);
    }

    public convertEnumToArray(value: any): Array<any> {
        let keys = [];
        for (var enumMember in value) {
            keys.push({ key: enumMember, value: value[enumMember] });
        }
        return keys;
    }

    public convertObjectIntoObject(sourceModel: any, newModel: any): any {
        const keys = Object.keys(sourceModel);

        keys.forEach((k) => {
            if (newModel.hasOwnProperty(k)) {
                newModel[k] = sourceModel[k];
            }
        });

        return newModel;
    }

    public convertFormGroupIntoObject(form: FormGroup, newModel: any): any {
        for (const prop in newModel) {
            if (form.controls.hasOwnProperty(prop)) {
                if (typeof newModel[prop] === 'number') {
                    let l_value = form.controls[prop].value;
                    if (l_value)
                        newModel[prop] = Number(l_value.toString().replace('$', ''));
                } else {
                    newModel[prop] = form.controls[prop].value;
                }
            }
        }

        return newModel;
    }

    /* We have tested all the modules and do not want to change the logic of other forms.
     * Create Member is a dynamic form where multiple inputs are not displayed.
     * So, we need to default to the new model constructor.
     */
    public convertFormGroupIntoObjectWithDefaultOverride(form: FormGroup, newModel: any): any {
        for (const prop in newModel) {
            if (form.controls.hasOwnProperty(prop)) {
                if (form.controls[prop].value)
                    newModel[prop] = form.controls[prop].value;
            }
        }

        return newModel;
    }

    public convertModelToList(model: any, keyText: string, keyValue: string): ListItem[] {
        const l_List = new Array<ListItem>();

        if (model) {
            for (var index in model) {

                let l_ListItem = new ListItem();
                for (var key in model[index]) {
                    if (key == keyText) {
                        l_ListItem.text = model[index][key];
                    }

                    if (key == keyValue) {
                        l_ListItem.value = model[index][key];
                    }
                }
                l_List.push(l_ListItem);
            }
        }

        return l_List;
    }

    public convertEnumToList(modelEnum: any): ListItem[] {
        const l_List = new Array<ListItem>();

        for (var enumMember in modelEnum) {
            let l_ListItem = new ListItem();
            l_ListItem.value = enumMember;
            l_ListItem.text = <any>modelEnum[enumMember];
            l_List.push(l_ListItem);
        }

        return l_List;
    }

    // checks validity of forms 
    public markFormGroupTouched(formGroup: FormGroup) {
        Object.values(formGroup.controls).forEach(control => {
            control.markAsTouched();
            if (control instanceof FormGroup) {
                this.markFormGroupTouched(control);
            }
        });
    }

    public async getBlobFormat(blob: Blob): Promise<string> {

        const reader = new FileReader();

        return new Promise<string>((resolve, reject) => {
            reader.onloadend = () => {
                const view = new Uint8Array(reader.result as ArrayBuffer).subarray(0, 4);
                let format = "";
                if (view[0] === 0x89 && view[1] === 0x50 && view[2] === 0x4E && view[3] === 0x47) {
                    format = ".png";
                } else if (view[0] === 0xFF && view[1] === 0xD8 && view[2] === 0xFF) {
                    format = ".jpg";
                } else if (view[0] === 0x25 && view[1] === 0x50 && view[2] === 0x44 && view[3] === 0x46) {
                    format = ".pdf";
                } else {
                    // Add more checks for other formats as needed
                    format = ".unknown";
                }

                resolve(format);
            };

            reader.onerror = () => {
                reject("Error reading the blob");
            };

            reader.readAsArrayBuffer(blob);
        });
    }
    /**
     * Used when you have the state abbreviation and need the full state name
     * 
     */
    public getStateName(abbreviation: string): string {
        switch (abbreviation.toUpperCase()) {
            case "AL": return "Alabama";
            case "AK": return "Alaska";
            case "AZ": return "Arizona";
            case "AR": return "Arkansas";
            case "CA": return "California";
            case "CO": return "Colorado";
            case "CT": return "Connecticut";
            case "DC": return "District of Columbia";
            case "DE": return "Delaware";
            case "FL": return "Florida";
            case "GA": return "Georgia";
            case "HI": return "Hawaii";
            case "ID": return "Idaho";
            case "IL": return "Illinois";
            case "IN": return "Indiana";
            case "IA": return "Iowa";
            case "KS": return "Kansas";
            case "KY": return "Kentucky";
            case "LA": return "Louisiana";
            case "ME": return "Maine";
            case "MD": return "Maryland";
            case "MA": return "Massachusetts";
            case "MI": return "Michigan";
            case "MN": return "Minnesota";
            case "MS": return "Mississippi";
            case "MO": return "Missouri";
            case "MT": return "Montana";
            case "NE": return "Nebraska";
            case "NV": return "Nevada";
            case "NH": return "New Hampshire";
            case "NJ": return "New Jersey";
            case "NM": return "New Mexico";
            case "NY": return "New York";
            case "NC": return "North Carolina";
            case "ND": return "North Dakota";
            case "OH": return "Ohio";
            case "OK": return "Oklahoma";
            case "OR": return "Oregon";
            case "PA": return "Pennsylvania";
            case "RI": return "Rhode Island";
            case "SC": return "South Carolina";
            case "SD": return "South Dakota";
            case "TN": return "Tennessee";
            case "TX": return "Texas";
            case "UT": return "Utah";
            case "VT": return "Vermont";
            case "VA": return "Virginia";
            case "WA": return "Washington";
            case "WV": return "West Virginia";
            case "WI": return "Wisconsin";
            case "WY": return "Wyoming";
            default: throw new Error("Invalid state abbreviation");
        }
    }

    public generateRandomString(length: number = 15): string {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()-=_+,.<>/;"';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    }

    public maskPhone(phone: string): string {
        if (!phone) return '';

        const digits = phone.replace(/\D/g, '');
        const last4 = digits.slice(-4);

        return `(xxx) xxx-${last4}`;
    }

    public formatDateString(value: string | null | undefined): string {
        if (!value) {
            return '';
        }

        const date = new Date(value);

        if (Number.isNaN(date.getTime())) {
            return value;
        }

        return new Intl.DateTimeFormat('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            timeZone: 'UTC',
        }).format(date);
    }
}